import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { OnboardingHowItWorksConstants, OnboardingIntroConstants } from '../../Config/UIConstants';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { Routes } from '../../_controllers/RouteController';
import {
    AudioCommentIcon,
    FamiliesIcon,
    GroupImageIcon,
    TightKnitLogoBrown,
    UploadPhotoIcon
} from '../../images/images';
import { colors } from '../../styles/colors';

export class OnboardingIntro extends React.Component<RouteComponentProps<any>> {

    private onPressNext = (): void => {
        this.props.history.push(Routes.ONBOARDING_CREATE_STORY);
    }

    private renderIconWithText(icon: any, text: string) {
        const adjustPadding = icon === UploadPhotoIcon;

        return (
            <div style={styles.iconTextContainer}>
                <img src={icon} style={styles.icon(adjustPadding)} />
                <p style={styles.iconText} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        );
    }

    public render() {
        return (
            <FullScreenModalContainer justifyContent="center" alignItems="center" {...this.props} onPressExit={() => this.props.history.push(Routes.ALBUMS)}>
                <div style={styles.topContainer}>{window.innerHeight > 800 && <img src={TightKnitLogoBrown} style={styles.logo} />}</div>
                <div style={{ ...styles.contentContainer, minHeight: 450 }}>
                    <p style={styles.headerText} dangerouslySetInnerHTML={{ __html: OnboardingIntroConstants.SUB_HEADER }} />

                    {this.renderIconWithText(GroupImageIcon, OnboardingHowItWorksConstants.CREATE_STORIES)}
                    {this.renderIconWithText(UploadPhotoIcon, OnboardingHowItWorksConstants.UPLOAD_PHOTOS)}
                    {this.renderIconWithText(AudioCommentIcon, OnboardingHowItWorksConstants.WRITE_COMMENTS)}
                    {this.renderIconWithText(FamiliesIcon, OnboardingHowItWorksConstants.CREATE_FAMILIES)}
                    <div style={styles.bottomBuffer} />
                    <p style={styles.iconText}>{OnboardingHowItWorksConstants.FINAL_INSTRUCTION}</p>
                </div>
                <div style={styles.bottomContainer}>
                    <CommonActionButton
                        buttonContent={OnboardingHowItWorksConstants.SETUP_PROFILE}
                        containerStyle={styles.buttonContainer}
                        fontStyle={styles.buttonText}
                        onClick={this.onPressNext}
                    />
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    bottomBuffer: {
        height: 30,
        width: '100%',
    },
    topContainer: {
        flex: 0.4,
        width: 350,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    } as React.CSSProperties,
    logo: {
        height: 155,
        width: 260,
        objectFit: 'contain',
    } as React.CSSProperties,
    bottomContainer: {
        height: 150,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 50,
    } as React.CSSProperties,
    contentContainer: {
        display: 'flex',
        flex: 0.6,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
    } as React.CSSProperties,
    headerText: {
        fontSize: 22,
        textAlign: 'center',
        width: 500,
        marginBottom: 15,
        color: colors.DARK_TEXT,
        // fontWeight: 800
    } as React.CSSProperties,
    subHeaderTop: {
        fontSize: 18,
        textAlign: 'center',
        width: '100%',
        marginBottom: 3,
    } as React.CSSProperties,
    subHeaderBottom: {
        fontSize: 18,
        textAlign: 'center',
        width: '100%',
        marginBottom: 52,
    } as React.CSSProperties,
    buttonContainer: {
        height: 48,
        width: 220,
    },
    buttonText: {
        fontSize: 14,
        fontWeight: 200,
        letterSpacing: 1,
    } as React.CSSProperties,
    icon: (adjustPadding: boolean): React.CSSProperties => {
        return {
            height: '100%',
            width: 50,
            objectFit: 'contain',
            marginRight: 20,
            paddingBottom: adjustPadding ? 15 : 0,
        };
    },
    iconTextContainer: {
        width: 600,
        display: 'flex',
        alignItems: 'center',
    } as React.CSSProperties,
    iconText: {
        fontSize: 16,
        // marginTop: 40
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingIntro.tsx